var exports = {
  "v0": "ProfileCardActions.module__iconMedium___UFpTeE",
  "wf": "ProfileCardActions.module__noteButtonContainer___UFpTeE",
  "_b": "ProfileCardActions.module__noteButtonContainerVisible___UFpTeE",
  "VI": "ProfileCardActions.module__noteButton___UFpTeE",
  "lY": "ProfileCardActions.module__noteTooltipContent___UFpTeE",
  "fg": "ProfileCardActions.module__noteIconWrapper___UFpTeE",
  "O8": "ProfileCardActions.module__copyIdButtonContainer___UFpTeE",
  "wG": "ProfileCardActions.module__copyIdButtonContainerVisible___UFpTeE",
  "pm": "ProfileCardActions.module__copyIdButton___UFpTeE",
  "Jt": "ProfileCardActions.module__copyIdIconWrapper___UFpTeE",
};

module.exports = exports;
